import VoicePolicies from 'pages/ga/voicePolicies/Index';
import VoicePoliciesForm from 'pages/ga/voicePolicies/Form';

const VoicePoliciesRoutes = [
    { index: true, element: <VoicePolicies /> },
    { path: 'add', element: <VoicePoliciesForm mode="add" /> },
    {
        path: 'edit/:id',
        element: <VoicePoliciesForm mode="edit" />,
    },
];

export default VoicePoliciesRoutes;
